export default {"id":"d3c0ec7f","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}